/**
 * Standalone browser bundle entry (IIFE, global `ArisRequestWatcher`).
 *
 * Built by build-browser.mjs into apps/dashboard/public/sdk/aris-watcher.js and
 * served by the dashboard at /sdk/aris-watcher.js, so any site — PHP, WordPress,
 * static HTML — can connect without npm or a build step:
 *
 *   <script src="https://arismon.ru/sdk/aris-watcher.js"></script>
 *   <script>
 *     ArisRequestWatcher.init({ projectId, environment, collectorUrl, apiKey });
 *   </script>
 */
export {
  initArisRequestWatcher,
  initArisRequestWatcher as init,
  metric,
  log,
  attachAxios,
  startTrace,
  captureException,
} from './index.js';
export type { ArisConfig } from './config.js';
export type { ArisHandle } from './index.js';
